/**
 * Centralized route constants. Use these instead of hardcoded path strings
 * so route renames don't ripple through the codebase.
 *
 * The constant NAMES are stable identifiers; the path VALUES below are the
 * current English slugs. Renaming a route only touches this file (plus the
 * redirect routes in App.tsx that forward the old German paths).
 */
export const ROUTES = {
  LANDING: '/',
  LANDING_DE: '/de',
  LOGIN: '/login',
  STANDARDISIERUNG: '/standardization',
  ZEITRASTEREINSTELLUNG: '/time-grid-setting',
  ANOMALIEERKENNUNG: '/anomaly-detection',
  DATA_ADJUSTMENTS: '/data-adjustments',
  DATENWOLKE: '/data-cloud',
  CSV_FILTER: '/data-filter',
  TRAINING: '/training',
  FORECAST_API: '/forecast-api',
  PRICING: '/pricing',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
